import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';

const NAV_LINKS = [
    { label: 'Products', href: '/#products' },
    { label: 'What we do', href: '/#what-we-do' },
    { label: 'About', href: '/about' },
];

function Header({ location }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    // Close the mobile menu whenever the route or section changes.
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname, location.hash]);

    return (
        <header className={`site-header${scrolled ? ' is-scrolled' : ''}${menuOpen ? ' is-open' : ''}`}>
            <div className="container site-header__inner">
                <Link to="/" className="brand" aria-label="Yay Fun, Inc. home">
                    <img src="/images/yayfun-mark.svg" alt="" width="36" height="36" className="brand__mark" />
                    <span className="brand__name">Yay Fun</span>
                </Link>

                <nav className="site-nav" aria-label="Primary">
                    {NAV_LINKS.map(link => (
                        <Link key={link.href} to={link.href} className="site-nav__link">
                            {link.label}
                        </Link>
                    ))}
                </nav>

                <button
                    type="button"
                    className="menu-toggle"
                    aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span></span>
                    <span></span>
                </button>
            </div>
        </header>
    )
}

export default withRouter(Header)
